module.exports = __webpack_public_path__ + "static/media/galerija_2021 (27).86c4cb74.jpg";